import { faCheck, faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import Button from "../../../../components/Button";
import Modal from "../../../../components/Modal"
import SimpleTable from "../../../../components/SimpleTable";
import { useColumns } from "./useColumns";

function InfoModal({ isOpen, values, close }) {
    const { t } = useTranslation();
    const columns = useColumns();
    const { type, data } = values || {};

    return (
        <Modal
            title={t("info")}
            isOpen={isOpen}
            size="lg"
            centered
        >
            <div className="mx-2 my-4" style={{ maxHeight: 300, overflow: "auto" }}>
                {type === "import" ? Object.keys(data || {}).map((employeeNumber) => {
                    const { status, message, ...rows } = data[employeeNumber];
                    const { inserted, failed } = Object
                        .entries(rows)
                        .reduce(
                            (total, [row, value]) => {
                                if (value.status) {
                                    total.inserted[row] = value;
                                } else {
                                    total.failed[row] = value;
                                }
                                return total;
                            },
                            { inserted: {}, failed: {} }
                        );

                    return (
                        <div
                            key={employeeNumber}
                            className="p-3 rounded mb-4"
                            style={{ backgroundColor: "#f7fafc" }}
                        >
                            <h3>
                                <span className="mr-3">
                                    {employeeNumber === 'emptyUser' ? (
                                        t('other')
                                    ) : `${t("employee")} ${employeeNumber}`}
                                </span>

                                {status ? (
                                    <>
                                        {!!Object.keys(inserted).length && (
                                            <span className="text-success mr-3">
                                                <FontAwesomeIcon icon={faCheck} />
                                                {Object.keys(inserted).length}
                                            </span>
                                        )}

                                        {!!Object.keys(failed).length && (
                                            <span className="text-danger mr-3">
                                                <FontAwesomeIcon icon={faClose} />
                                                {Object.keys(failed).length}
                                            </span>
                                        )}
                                    </>
                                ) : (
                                    <span className="text-danger">{message}</span>
                                )}
                            </h3>

                            {status && (
                                <div>
                                    {!!Object.keys(failed).length && (
                                        <hr className="my-2" />
                                    )}

                                    {Object.keys(failed).map((row) => {
                                        return (
                                            <div key={row} className="text-danger">
                                                <b>{t("row-{{count}}", { count: row })}:</b>
                                                {" "}
                                                <span>{failed[row].message}</span>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                        </div>
                    );
                }) : (
                    <SimpleTable data={data || []} columns={columns} footer={false} />
                )}
            </div>

            <div className="d-flex justify-content-end m-4">
                <Button
                    type="button"
                    color="dark"
                    onClick={close}
                >
                    {t("close")}
                </Button>
            </div>
        </Modal>
    );
}

export default InfoModal;
